define('pwa/model/NetworkStatusModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * @class NetworkStatusModel
     */
    return BaseModel.extend({
        isOnline: function () {
            return this.get('status') === 'online';
        },

        isOffline: function () {
            return this.get('status') === 'offline';
        },

        toJSON: function (options) {
            return _.extend(BaseModel.prototype.toJSON.apply(this, arguments), {
                is_change_network_status: this.hasChanged(),
                is_online: this.isOnline(),
                is_offline: this.isOffline(),
            });
        }
    });

});
